export const isAuthRoute = pathname => {
  const authRoutes = ['/sign-up', '/sign-in', '/reset-password', '/reset-password/requested']

  return authRoutes.includes(pathname)
}
